import getSymbolFromCurrency from 'currency-symbol-map'

export default getSymbolFromCurrency
